import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalCommentComponent } from './modal/modal-comment.component';
import { EditModalComponent } from './modal/edit-modal/edit-modal.component';
import { CloseTransactionModalComponent } from './close-transaction-modal/close-transaction-modal.component';
import {
    WithdrawModalEndTransactionComponent
} from './withdraw-modal-end-transaction/withdraw-modal-end-transaction.component';
import { ModalResultInfoComponent } from './modal-result-info/modal-result-info.component';
import { TransactionAllInfoModalComponent } from './transaction-all-info-modal/transaction-all-info-modal.component';
import { UpdateSupportStatusModalComponent } from './update-support-status-modal/update-support-status-modal.component';
import { SplitTransactionModalComponent } from './split-transaction-modal/split-transaction-modal.component';
import {
    ChangeTransactionStatusModalComponent
} from './change-transaction-status-modal/change-transaction-status-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { WithdrawBalanceModalComponent } from './withdraw-balance-modal/withdraw-balance-modal.component';
import { TextTableComponent } from './table/text-table/text-table.component';
import { ColumnComponent } from './table/column/column.component';
import { LabelComponent } from './label/label.component';
import { TransactionTabButtonComponent } from './transaction-tab-button/transaction-tab-button.component';
import { DateLabelContainerComponent } from './date-label-container/date-label-container.component';
import { StaticTransactionDataComponent } from './static-transaction-data/static-transaction-data.component';
import { StaticUserDataContainerComponent } from './static-user-data-container/static-user-data-container.component';
import { StatusLabelContainerComponent } from './status-label-container/status-label-container.component';
import { StatusMetadataContainerComponent } from './status-metadata-container/status-metadata-container.component';
import { ContainerSwitchComponent } from './table/container-switch/container-switch.component';
import { TransactionTabComponent } from './table/transaction-tab/transaction-tab.component';
import { FormComponent } from './form/form.component';
import { RoundButtonComponent } from './table/round-button/round-button.component';
import { TransactionTabListComponent } from './table/transaction-tab-list/transaction-tab-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { TransactionIdLabelComponent } from './table/transaction-id-label/transaction-id-label.component';
import { TransactionTabFooterComponent } from './table/transaction-tab-footer/transaction-tab-footer.component';
import { JsonTextComponent } from './json-text/json-text.component';
import { OpenFundistWrapperComponent } from './table/wrappers/open-fundist-wrapper.component';
import { TransactionTabHeaderComponent } from './table/transaction-tab-header/transaction-tab-header.component';
import { FailReasonWrapperComponent } from './fail-reason-wrapper/fail-reason-wrapper.component';
import {
    ConfirmTransactionWrapperComponent
} from './table/confirm-transaction-wrapper/confirm-transaction-wrapper.component';
import { StatusSelectorComponent } from './table/status-selector/status-selector.component';
import { SplitTransactionWrapperComponent } from './table/wrappers/split-transaction-wrapper.component';
import { CallbackComponent } from './table/callback/callback.component';
import { EditTransactionFormComponent } from './edit-transaction-form/edit-transaction-form.component';
import { EditTransactionWrapperComponent } from './table/wrappers/edit-transaction-wrapper/edit-transaction-wrapper.component';
import { ConfirmationDialogComponent } from './modal/confirmation-dialog/confirmation-dialog.component';
import { FooterWrapperComponent } from './table/wrappers/footer-wrapper/footer-wrapper.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatTabsModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalCommentComponent,
        CloseTransactionModalComponent,
        UpdateSupportStatusModalComponent,
        TransactionTabButtonComponent,
        StaticTransactionDataComponent,
        StaticUserDataContainerComponent,
        StatusLabelContainerComponent,
        TextTableComponent,
        ColumnComponent,
        LabelComponent,
        TransactionTabComponent,
        StatusMetadataContainerComponent,
        FormComponent,
        TransactionTabListComponent,
        TransactionIdLabelComponent,
        TransactionTabFooterComponent,
        OpenFundistWrapperComponent,
        TransactionTabHeaderComponent,
        JsonTextComponent,
        FailReasonWrapperComponent,
        RoundButtonComponent,
        ConfirmTransactionWrapperComponent,
        StatusSelectorComponent,
        SplitTransactionWrapperComponent,
        EditModalComponent,
        WithdrawModalEndTransactionComponent,
        ModalResultInfoComponent,
        TransactionAllInfoModalComponent,
        SplitTransactionModalComponent,
        ChangeTransactionStatusModalComponent,
        WithdrawBalanceModalComponent,
        DateLabelContainerComponent,
        ContainerSwitchComponent,
        CallbackComponent,
        EditTransactionFormComponent,
        EditTransactionWrapperComponent,
        FooterWrapperComponent

    ],
    declarations: [
        ModalCommentComponent,
        EditModalComponent,
        CloseTransactionModalComponent,
        WithdrawModalEndTransactionComponent,
        ModalResultInfoComponent,
        TransactionAllInfoModalComponent,
        UpdateSupportStatusModalComponent,
        SplitTransactionModalComponent,
        ChangeTransactionStatusModalComponent,
        WithdrawBalanceModalComponent,
        StatusLabelContainerComponent,
        TextTableComponent,
        ColumnComponent,
        LabelComponent,
        TransactionTabComponent,
        TransactionTabButtonComponent,
        DateLabelContainerComponent,
        ContainerSwitchComponent,
        StaticTransactionDataComponent,
        StaticUserDataContainerComponent,
        StatusMetadataContainerComponent,
        SplitTransactionWrapperComponent,
        TransactionIdLabelComponent,
        TransactionTabFooterComponent,
        OpenFundistWrapperComponent,
        TransactionTabHeaderComponent,
        JsonTextComponent,
        FailReasonWrapperComponent,
        ConfirmTransactionWrapperComponent,
        StatusSelectorComponent,
        TransactionTabListComponent,
        FormComponent,
        RoundButtonComponent,
        CallbackComponent,
        EditTransactionFormComponent,
        EditTransactionWrapperComponent,
        ConfirmationDialogComponent,
        FooterWrapperComponent
    ],
    providers: [DatePipe],
})
export class SharedModule {
}
